import { branch, drift, scrollEnd } from '../motifs';
import { M } from '../palette';
import { registerPlate } from '../registry';

const SNOW = '#ffffff';

/** 10 วสันต์: the winter plate, a pale blue scroll between its rollers, a snowy branch across it. */
registerPlate({
  id: 'winter',
  name: 'วสันต์',
  ground: ['#eef4fa', '#cfdcea', '#a4b8cc'],
  trim: '#5a789c',
  rail: ['#e8eef6', '#a8b8cc', '#6a7e98'],
  text: { fill: ['#2c4062', '#1a2440'], line: '#f4f8fc' },
  inset: [15, 9],
  knobs: false,
  tassels: [{ x: -4, charm: 'bead', charmTones: ['#e8f4ff', '#9ac8f0', '#5a88b8'] }],
  front(p, f) {
    scrollEnd(p, f.x, f.y - 4, f.b + 4);
    scrollEnd(p, f.r, f.y - 4, f.b + 4);
    branch(
      p,
      [
        [f.x - 9, f.y + 4],
        [f.x + 3, f.y - 4],
        [f.x + 14, f.y - 2],
        [f.x + 21, f.y + 4],
      ],
      2.2,
      0.7,
      M.brown,
    );
    branch(
      p,
      [
        [f.x + 4, f.y - 4],
        [f.x + 8, f.y - 11],
        [f.x + 13, f.y - 13],
      ],
      1.4,
      0.5,
      M.brown,
    );
    // Snow lying along the branch, and a few red plum buds through it.
    for (const [x, y, w] of [
      [f.x - 8, f.y + 1.5, 5],
      [f.x - 1, f.y - 5.5, 7],
      [f.x + 9, f.y - 4.5, 6],
      [f.x + 6, f.y - 12, 4],
      [f.x + 16, f.y - 1, 4],
    ] as const) {
      p.rect(x, y, w, 2, '#e4eef8');
      p.rect(x + 1, y - 1, w - 2, 2, SNOW);
    }
    for (const [x, y] of [
      [f.x + 1, f.y - 2],
      [f.x + 12, f.y - 1],
      [f.x + 11, f.y - 12],
    ] as const)
      p.rect(x, y, 2, 2, M.red).px(x + 1, y, M.redHi);
  },
  motion: {
    sprites: { flake: { w: 1, h: 1, draw: (p) => p.px(0, 0, SNOW) } },
    play(a, t, f) {
      drift(a, 'flake', t, 5, f.x - 6, 26, f.y - 12, f.b + 8, { speed: 0.2, sway: 1.5 });
      drift(a, 'flake', t, 2, f.r - 8, 8, f.y - 8, f.b + 6, { speed: 0.18, seed: 2 });
    },
  },
});
